import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import TruncateMarkup from 'react-truncate-markup';
import { propStr, propFunc, propId, propBool, } from '../../../../../helpers/custom-prop-types';
const ProfessionalUnitProjectCareerContent = (props) => {
    const { content, id, isHidden, onClickReadMore } = props;
    const [isTruncated, changeIsTruncated] = useState(false);
    if (isHidden) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'content_row' }, { children: [_jsx(TruncateMarkup, Object.assign({ lines: 4, onTruncate: changeIsTruncated }, { children: _jsx("div", Object.assign({ className: 'content_text' }, { children: content })) })), isTruncated && (_jsx("div", Object.assign({ className: 'content_read_more' }, { children: _jsx("button", Object.assign({ className: 'read_more_button link-text', onClick: onClickReadMore, type: 'button', value: id }, { children: "\u7D9A\u304D\u3092\u898B\u308B" })) })))] })));
};
ProfessionalUnitProjectCareerContent.propTypes = {
    content: propStr().isRequired,
    id: propId().isRequired,
    isHidden: propBool().isRequired,
    onClickReadMore: propFunc().isRequired,
};
export default ProfessionalUnitProjectCareerContent;
